import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";

export default function RegisterPage() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) { toast.success(t("auth.accountCreatedToast")); nav("/"); }
    else { setErr(r.error); toast.error(r.error); }
  }

  return (
    <div data-testid="register-page" className="px-6 md:px-10 lg:px-16 py-16 md:py-24 max-w-md mx-auto">
      <div className="overline mb-3">{t("auth.breadcrumbRegister")}</div>
      <h1 className="font-display font-bold text-5xl tracking-tighter leading-none mb-8">{t("auth.createAccount")}</h1>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="overline block mb-2">{t("auth.name")}</label>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="input-line" placeholder={t("auth.nameSample")} />
        </div>
        <div>
          <label className="overline block mb-2">{t("auth.email")}</label>
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-line" placeholder={t("auth.emailSample")} />
        </div>
        <div>
          <label className="overline block mb-2">{t("auth.password")}</label>
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-line" placeholder={t("auth.passwordHint")} />
        </div>
        {err && <div className="text-sm text-red-600" data-testid="register-error">{err}</div>}
        <button data-testid="register-submit" disabled={busy} className="btn-primary w-full justify-center">{busy ? t("auth.creating") : t("auth.create")}</button>
      </form>
      <div className="mt-6 text-sm text-gray-600">
        {t("auth.alreadyHave")} <Link to="/login" data-testid="register-to-login" className="underline">{t("auth.loginRedirect")}</Link>
      </div>
    </div>
  );
}
